<template>
  <v-dialog v-model="dialog.value" persistent max-width="600">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn rounded dark color="teal" v-on="{ ...dialogOn, ...tooltipOn }" @click="resetProperties">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Edytuj grupę</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Edycja grupy</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-form ref="form">
          <v-text-field
            v-model="form.name"
            label="Nazwa"
            name="name"
            type="text"
            :error-messages="nameErrors"
            @input="$v.form.name.$touch()"
            @blur="$v.form.name.$touch()"
          />
          <v-checkbox v-model="form.isActive" label="Aktywna"></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text--secondary" text :disabled="dialog.loading" @click="dialog.value = false">Anuluj</v-btn>
        <v-btn color="primary" text :loading="dialog.loading" @click="create">Aktualizuj</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('groups');

export default {
  mixins: [validationMixin],
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      },
      form: {
        name: null,
        isActive: null
      }
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) {
        return errors;
      }
      if (!this.$v.form.name.required) {
        errors.push('Imię jest wymagane');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    ...mapActions(['updateGroup']),
    resetProperties() {
      this.form.name = this.group.name;
      this.form.isActive = this.group.isActive;
      this.$v.$reset();
    },
    async create() {
      this.$v.$touch();

      if (this.formValid) {
        this.dialog.loading = true;

        await this.updateGroup({
          id: this.group.id,
          name: this.form.name,
          isActive: this.form.isActive
        });

        this.dialog.loading = false;
        this.dialog.value = false;
      }
    }
  }
};
</script>
